export function cx(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}

export const artifactMeta = {
  post: { label: 'Feedback', color: 'var(--feedback)', tone: 'feedback' },
  roadmap: { label: 'Roadmap', color: 'var(--roadmap)', tone: 'roadmap' },
  changelog: { label: 'Changelog', color: 'var(--cycle-blue)', tone: 'changelog' },
  decision: { label: 'Decision', color: 'var(--decision)', tone: 'decision' },
} as const;
